import './App.css';
import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from 'react-router-dom';
import Live from './Live';
import Ranking from './Ranking';
import LivePositions from './LivePositions';
import AutoSwitch from './AutoSwitch';


// Live shows all updates, so if a player comes out of the water, you'll see it
// but as soon as players start biking, those will be on top of the list
// until another wave comes out of the water, then those will be on top of the list
// ranking does not matter here.

// When players start finishing, another Live view is added to the top of the screen:
// It shows the finished players
// After a while the whole screen will be filled with finished players

// Live updates are fetches once via API call and get their following PlayerUpdates via sockets.

// When on / you're on AutoSwitch. AutoSwitch will switch from the Live view to the Ranking view
// 3 hours after the first player finishes

// The Ranking auto switches between rankings.
// Each Ranking view fetches the results from the results server via an API
// No sockets are used here.


// LivePositions was added for the app. It shows the ranking but live. But it doesn't show the rank number.
// Also users can click and switch category.
// Fetches PlayerUpdates at the start and gets his following PlayerUpdates via socket

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    return(
      <div className="App">
        <Router>
          <Switch>
            <Route path="/live" component={Live}/>
            <Route path="/ranking" component={Ranking} />
            <Route path="/positions/:viewIndex" component={LivePositions}/>
            <Route path="/positions">
              <Redirect to="/positions/0" />
            </Route>
            <Route path="/" component={AutoSwitch} />
          </Switch>
        </Router>


      </div>
    );
  }

}

export default App